module.exports = __webpack_public_path__ + "img/logo_2.396ece14.png";